import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportConfig, ReportDownloadTypes } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersModule, ReportFiltersComponent } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import {
  OrthognathicTreatmentReportTableComponentModule,
  OrthognathicTreatmentReportTableComponent
} from './components/orthognathic-treatment-report-table/orthognathic-treatment-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';

@Component({
  selector: 'stx-orthognathic-treatments-report',
  templateUrl: './orthognathic-treatments-report.component.html',
  imports: [
    GenericWidePageComponent,
    ReportHeaderComponent,
    ReportFiltersComponent,
    OrthognathicTreatmentReportTableComponent,
    AsyncPipe,
    TranslateModule
  ]
})
export class OrthognathicTreatmentsReportComponent {
  reportService = inject(ReportService);
  reportTableDataService = inject(ReportTableDataService);

  readonly reportConfig: ReportConfig = {
    type: 'ORTHOGNATHIC_TREATMENTS',
    downloadOptions: {
      [ReportDownloadTypes.EXCEL]: true
    },
    filters: {
      age: true,
      gender: true,
      geography: true,
      organizationsTree: true,
      recordDate: true
    }
  };

  applyFilters(pagination: PaginationSortingModel) {
    this.reportTableDataService.prepareList('ORTHOGNATHIC_TREATMENTS', this.reportService.model, pagination);
  }
}

@NgModule({
  imports: [
    ReportFiltersModule,
    OrthognathicTreatmentReportTableComponentModule,
    CommonModule,
    TranslateModule,
    GeneralCommonsModule,
    OrthognathicTreatmentsReportComponent
  ],
  exports: [OrthognathicTreatmentsReportComponent]
})
export class OrthognathicTreatmentsReportModule {}
